<template>
  <div class="main-content" id="content">
    <h3 class="marginBottom20">
      {{ `${type === "add" ? "新增" : type === "edit" ? "编辑" : "查看"}固件` }}
    </h3>
    <el-card style="padding-left: 50px">
      <el-form
        ref="form"
        :model="form"
        label-position="top"
        label-width="80px"
        :rules="rules"
      >
        <el-form-item label="固件名称" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入"
            style="width: 400px"
            maxlength="20"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item label="升级方式" prop="upgradeWay">
          <el-radio-group v-model="form.upgradeWay">
            <el-radio
              v-for="(item, index) in OUpgradeMethod"
              :key="index"
              :label="item.value"
              :disabled="true"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>

        <el-form-item label="升级范围" prop="upgradeScope">
          <el-radio-group v-model="form.upgradeScope">
            <el-radio
              v-for="(item, index) in OUpgradeScope"
              :key="index"
              :label="item.value"
              :disabled="true"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="选择设备"
          v-if="form.upgradeScope == 2"
          prop="deviceIds"
        >
          <div>{{ selectKey }}</div>
          <!-- <el-button type="primary" @click="selectTable">{{
            selectKey.length > 0 ? selectKey.length + "个设备" : "请选择"
          }}</el-button> -->
        </el-form-item>
        <div>产品类型</div>
        <div style="display: flex">
          <el-form-item label="产品系列" :span="8" prop="productSeries">
            <el-select
              v-model="form.productSeries"
              :disabled="true"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in OProductSeries"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="产品大类"
            class="marginLeft10"
            prop="productCategory"
          >
            <el-select
              v-model="form.productCategory"
              placeholder="请选择"
              @change="form.productSubCategory = ''"
              :disabled="true"
            >
              <el-option
                v-for="(item, index) in OProductType"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="产品子类"
            class="marginLeft10"
            prop="productSubCategory"
          >
            <el-select
              v-model="form.productSubCategory"
              :disabled="true"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in EProductSubType[form.productCategory]"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div>硬件版本</div>
        <div style="display: flex">
          <el-form-item label="PCB" :span="8" prop="hardwarePcb">
            <el-select
              v-model="form.hardwarePcb"
              :disabled="true"
              placeholder="请选择"
            >
              <el-option label="B" value="B"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="硬件版本"
            class="marginLeft10"
            prop="hardwareVersion"
          >
            <el-select
              v-model="form.hardwareVersion"
              placeholder="请选择"
              @change="form.hardwareBrandSubModel = ''"
              :disabled="true"
            >
              <el-option
                v-for="(item, index) in hardwareNumOne"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="子版本"
            class="marginLeft10"
            prop="hardwareSubVersion"
            :disabled="true"
          >
            <el-select
              v-model="form.hardwareSubVersion"
              :disabled="true"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in hardwareNumTwo"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- MCU -->
        <div style="display: flex">
          <el-form-item label="MCU" :span="8" prop="hardwareMcu">
            <el-select
              v-model="form.hardwareMcu"
              :disabled="true"
              placeholder="请选择"
            >
              <el-option label="M" value="M"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="品牌" class="marginLeft10" prop="hardwareBrand">
            <el-select
              v-model="form.hardwareBrand"
              placeholder="请选择"
              @change="form.hardwareBrandSubModel = ''"
              :disabled="true"
            >
              <el-option
                v-for="(item, index) in OMcuBrand"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="品牌子型号"
            class="marginLeft10"
            prop="hardwareBrandSubModel"
          >
            <el-select
              v-model="form.hardwareBrandSubModel"
              placeholder="请选择"
              :disabled="true"
            >
              <el-option
                v-for="(item, index) in EBrandSubModel[form.hardwareBrand]"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div>软件版本</div>
        <div style="display: flex">
          <el-form-item label="年月日" :span="8" prop="softwareData">
            <el-date-picker
              v-model="form.softwareData"
              type="date"
              placeholder="年月日"
              :disabled="true"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item
            label="版本"
            class="marginLeft20"
            prop="softwareVersion"
          >
            <el-select
              v-model="form.softwareVersion"
              :disabled="true"
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in version"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="子版本"
            class="marginLeft20"
            prop="softwareSubVersion"
          >
            <el-select
              v-model="form.softwareSubVersion"
              placeholder="请选择"
              :filterable="true"
              :disabled="true"
            >
              <el-option
                v-for="(item, index) in subversion"
                :key="index"
                :label="item.label"
                :value="item.value"
                :disabled="true"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <el-form-item label="上传固件" prop="firmwareUrl">
          <FormFileUpload
            :url="form.firmwareUrl"
            @upload="upload"
            :disabled="true"
            :limit="1"
            :maxSize="20"
            :accept="'bin'"
            :multiple="true"
            :isFileName="form.firmwareName"
          />
          <div style="color: #c0c1c3">文件格式：.bin</div>
        </el-form-item>

        <el-form-item label="版本描述" prop="versionDesc">
          <el-input
            type="textarea"
            v-model="form.versionDesc"
            style="width: 400px"
            maxlength="100"
            placeholder="请输入"
            :disabled="true"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="revert">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <Table
      :show="showTable"
      @handSelected="handSelected"
      @closeTable="closeTable"
      :selectKey="selectKey"
    />
  </div>
</template>

<script>
import { examineiManageView } from "@/api/examine/manage";
import {
  OProductType,
  OProductSeries,
  OUpgradeMethod,
  OUpgradeScope,
  OMcuBrand,
  EBrandSubModel,
  EProductSubType
} from "@/enums/beCurrent/EBeCurrent";
import FormFileUpload from "@/components/formComponents/formFileUpload";
import Table from "../table";
import dayjs from "dayjs";

export default {
  name: "create",
  components: {
    FormFileUpload,
    Table,
  },
  data() {
    return {
      OProductType: OProductType,
      OProductSeries: OProductSeries,
      OUpgradeMethod: OUpgradeMethod,
      OUpgradeScope: OUpgradeScope,
      OMcuBrand: OMcuBrand,
      EBrandSubModel: EBrandSubModel,
      EProductSubType: EProductSubType,
      id: this.$route.query.id,
      disabled: this.$route.query.type === "view",
      type: this.$route.query.type,
      form: {
        firmwareUrl: [],
        firmwareName: "",
        productSubCategory: "",
        upgradeScope: 1,
        upgradeWay: 1,
        hardwareBrandSubModel: "",
        hardwareBrand: "",
      },
      //校验规则
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        upgradeWay: [{ required: true, message: "请选择", trigger: "blur" }],
        upgradeScope: [{ required: true, message: "请选择", trigger: "blur" }],
        deviceIds: [
          {
            required: true,
            message: "请选择设备",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value.length === 0) {
                callback(new Error("请选择"));
              } else {
                callback();
              }
            },
          },
        ],
        productSeries: [{ required: true, message: "请选择", trigger: "blur" }],
        productCategory: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        productSubCategory: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        hardwarePcb: [{ required: true, message: "请选择", trigger: "blur" }],
        hardwareVersion: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        hardwareSubVersion: [
          { required: true, message: "请选择", trigger: "blur" },
        ],

        hardwareMcu: [{ required: true, message: "请选择", trigger: "blur" }],
        hardwareBrand: [{ required: true, message: "请选择", trigger: "blur" }],
        hardwareBrandSubModel: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        firmwareUrl: [
          {
            required: true,
            message: "请上传固件",
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value.length === 0) {
                callback(new Error("请上传"));
              } else {
                callback();
              }
            },
          },
        ],
        softwareData: [{ required: true, message: "请选择", trigger: "blur" }],
        softwareVersion: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        softwareSubVersion: [
          { required: true, message: "请选择", trigger: "blur" },
        ],
        versionDesc: [{ required: true, message: "请选择", trigger: "blur" }],
      },

      deviceList: [], //设备列表
      showTable: false,
      selectKey: [], //选中的设备列表
      hardwareNumOne: [], //硬件版本
      hardwareNumTwo: [], //硬件子版本
      loadingSubmit: false,
      version: [],
      subversion: [],
    };
  },
  mounted() {
    let numbers = [];
    let subversion = [];
    let newHardwareNumOne = [];
    let newHardwareNumTwo = [];
    for (let i = 0; i <= 99; i++) {
      const number = i.toString().padStart(2, "0");
      // if (i != 0) {
      numbers.push({ value: "A" + number, label: "A" + number });
      newHardwareNumOne.push({ value: number, label: number });
      // }
      newHardwareNumTwo.push({ value: number, label: number });
    }
    for (let i = 1; i <= 999; i++) {
      const number = i.toString().padStart(3, "0");
      subversion.push({ value: number, label: number });
    }

    this.version = numbers;
    this.subversion = subversion;

    this.hardwareNumOne = newHardwareNumOne;
    this.hardwareNumTwo = newHardwareNumTwo;
    this.getView();
  },
  methods: {
    async getView() {
      if (this.id) {
        const { data } = await examineiManageView(this.id);
        this.form = {
          ...data,
          firmwareUrl: [data.firmwareUrl],
          softwareData: dayjs(data.softwareDataTime, "YYMMDD").format(
            "YYYY-MM-DD"
          ),
          productCategory: data.productCategory,
        };
        if (data.upgradeScope == 2) {
          let newDeviceIds = data.deviceIds.split(",").map((item, index) => {
            return {
              id: item,
              deviceId: data.deviceIdsStr.split(",")[index],
            };
          });
          this.form.deviceIds = [...newDeviceIds];
          this.selectKey = data.deviceIdsStr;
        }
      }
    },
    //图片上传
    upload(e, name) {
      if (Array.isArray(e)) {
        this.form.firmwareUrl = [...e];
      } else {
        this.form.firmwareUrl = [...this.form.firmwareUrl, e];
      }
      this.form.firmwareName = name;
    },

    //打开设备表格
    selectTable() {
      this.showTable = true;
    },
    closeTable() {
      this.showTable = false;
    },
    handSelected(e) {
      this.selectKey = e;
      this.showTable = false;
      this.form.deviceIds = [...e];
    },
    revert() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
::v-deep
  .el-select-dropdown
  .el-scrollbar
  .el-scrollbar__view
  .el-select-dropdown__item {
  padding: 0 20px !important;
}
</style>
